import { Component, Input } from '@angular/core';
import { ComputedFrom } from '@certemy/common';

@Component({
  selector: 'cm-entry-header',
  templateUrl: './entry-header.component.html',
  styleUrls: ['./entry-header.component.scss', '../../../step-details.shared.scss'],
})
export class EntryHeaderComponent {
  @Input() step;

  @ComputedFrom('step')
  get criteriaRemaining(): number {
    return this.step.content.number_required - this.step.content.number_completed;
  }

  getComplianceCriteriaType() {
    return this.step._hoursFlow ? 'Hours' : 'Entries';
  }
}
